import { IOnboardingRepository } from '../../domain/repositories/IOnboardingRepository';
import { OnboardingProgressDTO } from '../dto/OnboardingProgressDTO';
import { OnboardingMapper } from '../mappers/OnboardingMapper';

/**
 * StartOnboardingUseCase
 * Initiates the onboarding process for a user
 *
 * Business Logic:
 * - Changes status from 'pending' to 'in_progress'
 * - Records startedAt timestamp
 * - Returns updated progress DTO
 */
export class StartOnboardingUseCase {
  constructor(private readonly repository: IOnboardingRepository) {}

  /**
   * Execute the use case
   *
   * @param userId - UUID of the user
   * @param role - User role ('director' | 'teacher' | 'student')
   * @returns Promise<OnboardingProgressDTO> - Updated progress
   */
  async execute(userId: string, role: string): Promise<OnboardingProgressDTO> {
    const progress = await this.repository.startOnboarding(userId, role);
    return OnboardingMapper.progressToDTO(progress);
  }
}
